<template>
  <div class="crpg-o-common-header">
    <div class="crpg-o-common-header__function">
      <div class="crpg-o-common-header__container">
        <div class="crpg-o-common-header__logo-image">
          <CMS
            contents_type="block_contents"
            location_code="CRPG_TOP_01_001-logo"
          />
        </div>

        <ul class="crpg-o-common-header__menu">
          <li v-show="shouldShowAboutLink" @click="$router.push(aboutLink)" class="crpg-o-common-header__menuItem">ABOUT</li>
          <li>
            <a :href="link" class="crpg-o-common-header__menuItem">
              &#12525;&#12464;&#12452;&#12531;</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getActiveSubDirectory, checkIfShouldShowAboutLink } from "@/utils/subDirectoryUtils.js";
import CMS from "@/components/CMS.vue";

export default {
  name: "CrpgOrganismsCommonHeader",
  components: {
    CMS,
  },
  data() {
    return {
      shouldShowAboutLink: false,
    };
  },
  computed: {
    aboutLink() {
      const activeSubDirectory = getActiveSubDirectory(this.$route.path);
      return activeSubDirectory ? `${activeSubDirectory}/about` : "/about";
    },
    link() {
      return process.env.VUE_APP_LOGIN;
    },
  },
  mounted() {
    this.updateShouldShowAboutLink();
  },
  methods: {
    updateShouldShowAboutLink() {
      const activeSubDirectory = getActiveSubDirectory(this.$route.path);
      const originPath = window.location.origin;
      const aboutLinkPath = activeSubDirectory ? `${originPath}${activeSubDirectory}` : originPath;
      this.shouldShowAboutLink = checkIfShouldShowAboutLink(aboutLinkPath);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/organisms/common/header.scss";
</style>
